<select style="width: 100%" (change)="onChange($event.target.value)">
	<option
		*ngFor="let option of this.params.valueOptions"
		value="{{ option.value }}"
		[ngStyle]="option.labelStyle"
		[selected]="this.selectedObject == option"
		[innerHTML]="option.label"
	></option>
</select>
